import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {CommonService} from "../services/common.service";

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard {
  constructor(
    private router: Router,
    private commonService: CommonService,
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isLoggedIn = this.commonService.isAuthenticated(); // ... your authentication logic here

    if (isLoggedIn) {
      return true;
    }

    this.router.navigate(['']);
    return false;
  }
}
